import { useEffect, useRef, useState } from "react";
import { Heart, Music2 } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { SectionTitle } from "@/components/Wave";

const Placeholder = () => (
  <div data-testid="tiktok-placeholder" className="mt-10 grid grid-cols-3 gap-3 sm:gap-5 max-w-3xl">
    {["POV: grandpa outsurfs you", "Daily duo unboxing", "Morning routine"].map((t, i) => (
      <div key={t} className={`relative aspect-[9/16] rounded-2xl border border-cream/80 bg-navy-dark overflow-hidden ${i === 1 ? "-translate-y-4" : ""}`}>
        <div className="absolute inset-0 bg-gradient-to-b from-aqua/20 to-transparent" />
        <div className="absolute bottom-3 left-3 right-3 text-cream">
          <p className="text-xs sm:text-sm font-bold leading-tight">{t}</p>
          <p className="mt-1 flex items-center gap-1 text-[10px] sm:text-xs text-cream/70"><Music2 className="h-3 w-3" /> coming soon</p>
        </div>
        <Heart className="absolute right-3 top-1/2 h-5 w-5 text-coral fill-coral" />
      </div>
    ))}
  </div>
);

export const TikTokFeed = () => {
  const { settings } = useStore();
  const handle = settings?.tiktok_handle;
  const box = useRef(null);
  const [near, setNear] = useState(false);
  useEffect(() => {
    if (!handle || !box.current) return;
    const io = new IntersectionObserver(([e]) => e.isIntersecting && setNear(true), { rootMargin: "400px" });
    io.observe(box.current);
    return () => io.disconnect();
  }, [handle]);
  useEffect(() => {
    if (!handle || !near) return;
    const s = document.createElement("script");
    s.src = "https://www.tiktok.com/embed.js";
    s.async = true;
    document.body.appendChild(s);
    return () => { s.remove(); };
  }, [handle, near]);
  return (
    <section ref={box} data-testid="tiktok-section" className="bg-navy text-cream relative grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <SectionTitle light chip="TikTok" title={<>Grandpa's <span className="text-aqua">on TikTok</span></>}
          sub={handle ? `Follow @${handle} for daily dad-joke-level wisdom.` : "Grandpa's warming up his thumbs. The feed drops soon."} />
        {handle ? (
          <div className="mt-10 bg-cream rounded-2xl border border-cream overflow-hidden" data-testid="tiktok-embed">
            <blockquote className="tiktok-embed" cite={`https://www.tiktok.com/@${handle}`} data-unique-id={handle} data-embed-type="creator" style={{ maxWidth: "780px", minWidth: "288px" }}>
              <section><a target="_blank" rel="noreferrer" href={`https://www.tiktok.com/@${handle}`}>@{handle}</a></section>
            </blockquote>
          </div>
        ) : <Placeholder />}
      </div>
    </section>
  );
};
